export const EMPTY_ARRAY = [];
export const GREYSCOUT_COMPANY_ID = '1';
export const ALLOW_STORE_PERIODS = [30, 60, 90, 180, 360];
export const MAX_HEADING_LEVEL = 2;
export const HEADING_LEVELS = ([1, 2, 3, 4, 5, 6] as const).slice(0, MAX_HEADING_LEVEL);
export const LOOKER_URL = 'https://looker.greyscout.com';
export const AUXILIARY_BUTTON_INDEX = 1;
export const NO_BRAND_OPTION_ID = 'null';
export const IMAGE_PLACEHOLDER_PATH = 'companies/1/branding/no_image.png';
export const MIN_ZOOM_SCALE = 1;
export const MAX_ZOOM_SCALE = 5;
export const MULTIPLE_ACTION_BATCH_SIZE = Number(import.meta.env.VITE_MULTIPLE_ACTION_BATCH_SIZE) || 10;
